import * as moment from 'moment';
import { State } from '../state';
const STANDARD_LOGO = '/assets/logo/blue.png';

export const competitionName = (state: State) => {
  return (state.competition && state.competition.name) || state.initialQuery.competitionName;
};
export const competitionLogoUrl = (state: State) => {
  return (state.competition && state.competition.logoUrl) || STANDARD_LOGO;
};

export const hasCompetitionStarted = (state: State) => {
  if (!state.competition) return false;
  return moment(state.competition.startsAt).isBefore(Date.now());
};

export const hasCompetitionEnded = (state: State) => {
  if (!state.competition) return false;
  return moment(state.competition.endsAt).isBefore(Date.now());
};

export const competitionDescription = (state: State) => {
  if (!state.competition) return '';
  return state.competition.description;
};
